import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../constant/fieldNames"
import getDisplayCondition from "../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../types"
import OneClickField from "../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../constant/helpLinks"

import img from "./ulMark.png"

const ULマーク = ({ values, handlers, errors }: OneClickFieldProps) => {
  const isULMarkInSpecificPosition = values.ulMark === ESTIMATE_CONSTANT.ULマーク.位置指定あり.value
  const { ulMark: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField isShow={shouldShow} legend="ULマーク" helpURL={HELP_LINKS.ULマーク} src={img}>
      <RadioGroup name={FIELD_NAMES.ULマーク} selectedValue={values.ulMark} onChange={handlers.radio}>
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT.ULマーク.なし.value}>なし</Radio>
          <Radio value={ESTIMATE_CONSTANT.ULマーク.位置指定あり.value}>位置指定あり</Radio>
          <Radio value={ESTIMATE_CONSTANT.ULマーク.位置指定なし.value}>位置指定なし</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.ulMark}>
        {isULMarkInSpecificPosition && <p>※ご注文の際は、挿入イメージ図が必要となります。</p>}
      </OneClickFieldMessages>
    </OneClickField>
  )
}

export default ULマーク
